export default __webpack_public_path__ + "static/media/Matrix.e4467caa.PNG";